import axios from 'axios';
import { baseURL1 } from '../utils/baseUrl';

const api = axios.create({
  baseURL: baseURL1,
});

export const getWithLang = async (endpoint, language, params = {}) => {
  const response = await api.get(endpoint, {
    params: { ...params, language }, 
  });
  return response.data;
};

export default api;
